import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const IncomingIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 22 22" sx={{ height: '22px', width: '22px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M11 3.6665V18.3332M11 18.3332L16.5 12.8332M11 18.3332L5.5 12.8332"
        stroke="#24B07E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default IncomingIcon;
